var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 15.4062H2.125C1.83281 15.4062 1.59375 15.1672 1.59375 14.875V7.4375C1.59375 7.14531 1.83281 6.90625 2.125 6.90625H3.71875V5.3125H2.125C0.95293 5.3125 0 6.26543 0 7.4375V14.875C0 16.0471 0.95293 17 2.125 17H9.5625C10.7346 17 11.6875 16.0471 11.6875 14.875V13.2812H10.0938V14.875C10.0938 15.1672 9.85469 15.4062 9.5625 15.4062ZM7.4375 10.0938C7.14531 10.0938 6.90625 9.85469 6.90625 9.5625V2.125C6.90625 1.83281 7.14531 1.59375 7.4375 1.59375H14.875C15.1672 1.59375 15.4062 1.83281 15.4062 2.125V9.5625C15.4062 9.85469 15.1672 10.0938 14.875 10.0938H7.4375ZM5.3125 9.5625C5.3125 10.7346 6.26543 11.6875 7.4375 11.6875H14.875C16.0471 11.6875 17 10.7346 17 9.5625V2.125C17 0.95293 16.0471 0 14.875 0H7.4375C6.26543 0 5.3125 0.95293 5.3125 2.125V9.5625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.55d0097c08d0e10876faa9b4082c6e19.svg";
export { ForwardRef as ReactComponent };